var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg0({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.635735 32.5C0.635735 50.3743 15.1257 64.8643 33 64.8643C50.8743 64.8643 65.3643 50.3743 65.3643 32.5C65.3643 14.6257 50.8743 0.135742 33 0.135742C15.1257 0.135742 0.635735 14.6257 0.635735 32.5ZM51.7348 32.5C51.7348 42.8469 43.3469 51.2348 33 51.2348C22.6531 51.2348 14.2652 42.8469 14.2652 32.5C14.2652 22.1531 22.6531 13.7652 33 13.7652C43.3469 13.7652 51.7348 22.1531 51.7348 32.5Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.770caddf1f45301aa156b7cf775671a2.svg";
export { ForwardRef as ReactComponent };